import React from 'react';

export default () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 26 25"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.1 16.622a4.938 4.938 0 0 1 6.968 0 4.897 4.897 0 0 1 0 6.94 4.938 4.938 0 0 1-6.968 0 4.888 4.888 0 0 1 0-6.94zm4.955-8.49v6.123a6.053 6.053 0 0 0-5.749 1.582 6.01 6.01 0 0 0-1.542 5.918H.511V8.133h21.544zm-1.614 8.705a.45.45 0 0 0-.456.454v3.071c0 .255.195.454.456.454h2.552a.442.442 0 0 0 .45-.454.45.45 0 0 0-.456-.454h-2.09v-2.617a.447.447 0 0 0-.456-.454zm-13.874-.995h-2.87v2.24h2.87v-2.24zm6.153 0H9.85v2.24h2.87v-2.24zm6.133-5.352h-2.87v2.26h2.87v-2.26zm-12.286 0h-2.87v2.24h2.87v-2.24zm6.153 0H9.85v2.24h2.87v-2.24zM1.786 2.26v1.607c0 .95.79 1.725 1.742 1.725A1.73 1.73 0 0 0 5.26 3.867V2.26h1.711v1.607a1.733 1.733 0 0 0 3.464 0V2.26h1.67v1.607a1.733 1.733 0 0 0 3.464 0V2.26h1.711v1.607a1.733 1.733 0 0 0 3.463 0V2.26h1.291v4.72H.511V2.26h1.275zM19.032 0a.58.58 0 0 1 .58.577v3.285a.58.58 0 0 1-.58.577.573.573 0 0 1-.579-.572V.577a.58.58 0 0 1 .58-.577zm-5.18 0a.58.58 0 0 1 .58.577v3.285a.58.58 0 0 1-.58.577c-.297 0-.558-.255-.579-.572V.577a.58.58 0 0 1 .58-.577zM8.698 0a.58.58 0 0 1 .579.577v3.285a.58.58 0 0 1-.58.577.573.573 0 0 1-.578-.572V.577A.58.58 0 0 1 8.698 0zm-5.16 0c.318 0 .58.255.58.577v3.285a.58.58 0 0 1-.58.577.576.576 0 0 1-.578-.572V.577c0-.322.26-.577.579-.577z"
        fill="#464E5F"
        fillRule="evenodd"
      />
    </svg>
  );
};
